import axios from "axios";
import React, { useEffect, useState } from "react";
import FormatDate from "../../formatdatetime";
import { baseurl } from "../../constant";
import Loading from "../../loading";

const BillPayCommission = () => {
  const [data, setdata] = useState();
  const [err, seterr] = useState();
  const [datalength, setdatalength] = useState();
  const [loading, setloading] = useState(false);

  const token = localStorage.getItem("authToken");
  // const pageRecord = 50;
  // const totalPage = Math.ceil(totalrecord / pageRecord);
  // const SerialNumber = (currentPage - 1) * pageRecord + index;

  // const handlePageChange = (newPage) => {
  //   setCurrentPage(newPage);
  // };

  // Pagination(totalPage, currentPage);

  // var pages = [];
  // const maxvisablepage = 8;
  // if (totalPage <= maxvisablepage) {
  //   for (let i = 1; i <= totalPage; i++) {
  //     pages.push(i);
  //   }
  // } else {
  //   if (currentPage <= 3) {
  //     // Show first 3 pages, then ellipsis, then last page
  //     pages.push(1, 2, 3, ".......", totalPage);
  //   } else if (currentPage >= totalPage - 2) {
  //     // Show first page, then ellipsis, then last 3 pages
  //     pages.push(1, totalPage - 2, totalPage - 1, totalPage);
  //   } else {
  //     // Show first page, ellipsis, current page & its neighbors, ellipsis, last page
  //     pages.push(1, currentPage - 1, currentPage, currentPage + 1, totalPage);
  //   }
  // }

  const getdata = async () => {
    try {
      setloading(true);
      const result = await axios.post(baseurl + "myBbpsCommissionAuth", {
        token: token,
      });

      setdata(result.data.data);
      setdatalength(result.data.data.length);
      setloading(false);
    } catch (err) {
      seterr(err);
    }
  };
  useEffect(() => {
    getdata();
  }, []);

  return (
    <>
      <div className="card shadow mb-4">
        <form
          id="admin_profile"
          enctype="multipart/form-data"
          method="post"
          accept-charset="utf-8"
        >
          <input type="hidden" name="method" value="post" />
          <div className="card-header py-3">
            <div className="row">
              <div className="col-sm-8">
                <h4>
                  <b>My Recharge Commission</b>
                </h4>
              </div>
            </div>
          </div>

          <div className="card-body">
            <div className="table-responsive" id="recharge-comm-block">
              <table
                className="table table-bordered table-striped"
                width="100%"
                cellspacing="0"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Operator</th>
                    <th>Code</th>
                    <th>Type</th>
                    <th>Commission</th>
                    <th>Is Flat ?</th>
                    <th>Is Surcharge ?</th>
                  </tr>
                </thead>

                {datalength > 0 ? (
                  <tbody>
                    {data.map((item, index) => (
                      <tr>
                        <td>{index + 1}</td>
                        <td>{item.operator_name}</td>
                        <td>{item.operator_code}</td>
                        <td>{item.type}</td>

                        {data ? (
                          item.commision == null && <td>0</td>
                        ) : (
                          <td>{item.commision}</td>
                        )}

                        {data ? (
                          item.is_flat == null && (
                            <td>
                              <font color="red">No</font>
                            </td>
                          )
                        ) : (
                          <td>
                            <font color="green">yes</font>
                          </td>
                        )}

                        {data ? (
                          item.is_surcharge === null && (
                            <td>
                              <font color="red">No</font>
                            </td>
                          )
                        ) : (
                          <td>
                            <font color="green">yes</font>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                ) : (
                  <tr>
                    <th colspan="11" style={{ textAlign: "center" }}>
                      No matching records found
                    </th>
                  </tr>
                )}

                <tfoot>
                  <tr>
                    <th>#</th>
                    <th>Operator</th>
                    <th>Code</th>
                    <th>Type</th>
                    <th>Commission</th>
                    <th>Is Flat ?</th>
                    <th>Is Surcharge ?</th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default BillPayCommission;
